var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMuvuCmt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-88d29150-55b7-4e00-b7f9-5daa9be950ab",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 402.94 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-19397eca-e8d1-4e83-9183-efa7e285e71d",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m302.08,15.92c2.6,0,4.75-1.15,6.01-2.99l-2.32-1.66c-.85,1.23-2.13,1.94-3.71,1.94-2.51,0-4.49-1.79-4.5-4.64,0-2.75,1.92-4.63,4.5-4.63,1.59,0,2.88.73,3.68,1.95l2.44-1.49c-1.16-1.98-3.48-3.18-6.1-3.18-4.38,0-7.48,3.09-7.48,7.35s3.1,7.34,7.48,7.34Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.95,15.92c1.66,0,3.08-.47,4.2-1.49l-1.56-1.7c-.72.6-1.64.94-2.49.94-1.25,0-2.25-.62-2.54-2.04h6.99c.03-.22.05-.59.05-.89-.01-3.05-1.95-5.15-4.79-5.15s-4.99,2.11-4.99,5.19,2.1,5.13,5.12,5.13Zm-.15-8.05c1.14,0,1.9.71,2.15,1.96h-4.37c.23-1.21.97-1.96,2.22-1.96Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.45,10.29c0-1.47.94-2.22,2.08-2.22,1.21,0,1.92.78,1.92,2.2v5.39h2.65v-6.24c0-2.28-1.6-3.83-3.84-3.83-1.12,0-2.2.38-2.9,1.42v-1.16h-2.58v9.8h2.66v-5.37Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.76,12c0,2.54,1.25,3.92,3.69,3.92,1.4,0,2.4-.45,3.27-1.03l-.98-2.06c-.54.32-1.22.64-1.85.64-.82,0-1.47-.44-1.47-1.67v-3.58h3.57v-2.35h-3.57v-2.91h-2.66v2.91h-1.9v2.35h1.9v3.8Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.99,10.32c0-1.46.85-2.21,2.08-2.21.54,0,1.17.12,1.61.31l.4-2.62c-.37-.13-.81-.21-1.38-.21-1.21,0-2.16.42-2.78,1.34v-1.08h-2.57v9.8h2.65v-5.34Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.6,15.92c3.07,0,5.34-2.21,5.34-5.16s-2.27-5.16-5.34-5.16-5.32,2.21-5.32,5.16,2.26,5.16,5.32,5.16Zm0-7.86c1.49,0,2.62,1.11,2.62,2.7s-1.13,2.7-2.62,2.7-2.61-1.11-2.61-2.7,1.12-2.7,2.61-2.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311 41.7 311 27.54 306.85 27.54 303.15 37.1 299.45 27.54 295.29 27.54 295.29 41.7 298.13 41.7 298.13 31.09 301.64 40.34 304.65 40.34 308.17 31.01 308.17 41.7 311 41.7",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.75,40.47l-1.56-1.7c-.71.59-1.63.94-2.49.94-1.25,0-2.25-.62-2.53-2.03h6.99c.04-.22.06-.59.06-.89-.01-3.06-1.96-5.15-4.79-5.15s-4.98,2.1-4.98,5.19,2.09,5.13,5.12,5.13c1.66,0,3.08-.47,4.2-1.49Zm-4.36-6.56c1.14,0,1.9.71,2.15,1.96h-4.37c.24-1.22.97-1.96,2.22-1.96Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.61 30.49 319.15 30.49 321.83 27.3 318.66 27.3 316.61 30.49",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.5,40.62v1.08h2.59v-14.57h-2.65v5.79c-.64-.77-1.58-1.29-2.9-1.29-2.71,0-4.77,2.22-4.77,5.16s2.05,5.16,4.77,5.16c1.35,0,2.31-.55,2.95-1.33Zm-5-3.82c0-1.5.98-2.7,2.54-2.7s2.54,1.15,2.54,2.7-1.03,2.7-2.54,2.7-2.54-1.21-2.54-2.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.21,26.99c-.96,0-1.69.75-1.69,1.7s.73,1.68,1.69,1.68,1.7-.73,1.7-1.68-.74-1.7-1.7-1.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.89,
    y: 31.9,
    width: 2.65,
    height: 9.8,
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.05,38.51c-.56.61-1.29.99-2.15.99-1.37,0-2.46-1.06-2.46-2.7s1.1-2.7,2.47-2.7c.86,0,1.5.34,2.1.98l1.91-1.59c-.91-1.18-2.3-1.85-3.95-1.85-3.14,0-5.25,2.2-5.25,5.16s2.11,5.16,5.25,5.16c1.65,0,3.03-.66,3.96-1.84l-1.89-1.61Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.25,36.8c0,2.95,2.26,5.16,5.32,5.16s5.34-2.2,5.34-5.16-2.27-5.16-5.34-5.16-5.32,2.21-5.32,5.16Zm7.95,0c0,1.59-1.13,2.7-2.63,2.7s-2.61-1.11-2.61-2.7,1.12-2.7,2.61-2.7,2.63,1.11,2.63,2.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.3,41.95c1.36,0,2.31-.55,2.95-1.33v1.08h2.59v-14.57h-2.64v5.79c-.64-.77-1.58-1.29-2.9-1.29-2.71,0-4.77,2.22-4.77,5.16s2.06,5.16,4.77,5.16Zm.49-7.86c1.51,0,2.54,1.15,2.54,2.7s-1.03,2.7-2.54,2.7-2.54-1.21-2.54-2.7.98-2.7,2.54-2.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.15,41.95c1.66,0,3.08-.47,4.2-1.49l-1.56-1.7c-.71.59-1.64.94-2.49.94-1.25,0-2.25-.62-2.53-2.03h6.99c.03-.22.05-.59.05-.89-.01-3.06-1.95-5.15-4.79-5.15s-4.98,2.1-4.98,5.19,2.1,5.13,5.12,5.13Zm-.15-8.05c1.14,0,1.9.71,2.15,1.96h-4.37c.24-1.22.97-1.96,2.22-1.96Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 27.13,
    width: 2.65,
    height: 14.57,
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294 56.21 298.41 56.21 298.41 67.74 301.25 67.74 301.25 56.21 305.66 56.21 305.66 53.57 294 53.57 294 56.21",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.97,59.01v-1.07h-2.57v9.8h2.66v-5.34c0-1.46.85-2.21,2.08-2.21.54,0,1.17.12,1.61.32l.4-2.62c-.37-.13-.82-.21-1.39-.21-1.21,0-2.16.42-2.78,1.34Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.07,59.02c-.65-.8-1.59-1.35-2.95-1.35-2.71,0-4.77,2.21-4.77,5.16s2.06,5.16,4.77,5.16c1.36,0,2.31-.55,2.95-1.34v1.08h2.59v-9.8h-2.59v1.08Zm-2.46,6.52c-1.56,0-2.55-1.2-2.55-2.7s.99-2.7,2.55-2.7,2.54,1.15,2.54,2.7-1.03,2.7-2.54,2.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334,57.67c-1.32,0-2.25.52-2.89,1.28v-5.79h-2.64v14.57h2.59v-1.08c.64.79,1.59,1.34,2.95,1.34,2.72,0,4.77-2.22,4.77-5.16s-2.05-5.16-4.78-5.16Zm-.49,7.86c-1.51,0-2.54-1.15-2.54-2.7s1.03-2.7,2.54-2.7,2.54,1.21,2.54,2.7-.97,2.7-2.54,2.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.07,59.02c-.66-.8-1.6-1.35-2.95-1.35-2.71,0-4.77,2.21-4.77,5.16s2.06,5.16,4.77,5.16c1.35,0,2.31-.55,2.95-1.34v1.08h2.59v-9.8h-2.59v1.08Zm-2.46,6.52c-1.56,0-2.54-1.2-2.54-2.7s.99-2.7,2.54-2.7,2.54,1.15,2.54,2.7-1.03,2.7-2.54,2.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.81,53.02c-.95,0-1.69.75-1.69,1.7s.73,1.68,1.69,1.68,1.7-.73,1.7-1.68-.74-1.7-1.7-1.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.51,68.52c0,.75-.35,1.02-.79,1.02-.26,0-.49-.04-.72-.12l-.39,2.32c.38.16,1.02.26,1.5.26,1.82,0,3.06-1.19,3.06-3.33v-10.74h-2.66v10.58Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.07,59.02c-.65-.8-1.6-1.35-2.95-1.35-2.71,0-4.77,2.21-4.77,5.16s2.06,5.16,4.77,5.16c1.35,0,2.31-.55,2.95-1.34v1.08h2.59v-9.8h-2.59v1.08Zm-2.46,6.52c-1.56,0-2.55-1.2-2.55-2.7s.98-2.7,2.55-2.7,2.54,1.15,2.54,2.7-1.02,2.7-2.54,2.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.53,58.96c-.64-.77-1.58-1.28-2.9-1.28-2.71,0-4.77,2.21-4.77,5.16s2.06,5.16,4.77,5.16c1.36,0,2.31-.55,2.95-1.34v1.08h2.59v-14.57h-2.65v5.79Zm-2.41,6.58c-1.56,0-2.54-1.2-2.54-2.7s.98-2.7,2.54-2.7,2.54,1.15,2.54,2.7-1.03,2.7-2.54,2.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.68,57.67c-3.06,0-5.32,2.21-5.32,5.16s2.26,5.16,5.32,5.16,5.34-2.21,5.34-5.16-2.27-5.16-5.34-5.16Zm0,7.86c-1.5,0-2.61-1.11-2.61-2.7s1.12-2.7,2.61-2.7,2.62,1.11,2.62,2.7-1.13,2.7-2.62,2.7Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.56,57.67c-1.21,0-2.15.42-2.77,1.34v-1.07h-2.58v9.8h2.65v-5.34c0-1.46.85-2.21,2.08-2.21.54,0,1.17.12,1.61.32l.4-2.62c-.37-.13-.81-.21-1.38-.21Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.96,
    width: 2.41,
    height: 70.72,
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.18,13c-5.02,0-9.67,2.17-12.9,5.98-3.23-3.81-7.88-5.98-12.9-5.98-9.34,0-16.94,7.6-16.94,16.94v22.4c0,2.22,1.81,4.03,4.03,4.03s4.03-1.81,4.03-4.03v-22.4c0-4.89,3.98-8.87,8.87-8.87s8.87,3.98,8.87,8.87v22.4c0,2.22,1.81,4.03,4.03,4.03s4.03-1.81,4.03-4.03v-22.4c0-4.89,3.98-8.87,8.87-8.87s8.87,3.98,8.87,8.87v22.4c0,2.22,1.81,4.03,4.03,4.03s4.03-1.81,4.03-4.03v-22.4c0-9.34-7.6-16.94-16.94-16.94Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.39,14.92c-2.22,0-4.03,1.81-4.03,4.03v21.14c0,4.89-3.98,8.87-8.87,8.87s-8.87-3.98-8.87-8.87v-21.14c0-2.22-1.81-4.03-4.03-4.03s-4.03,1.81-4.03,4.03v21.14c0,9.34,7.6,16.93,16.94,16.93s16.94-7.6,16.94-16.93v-21.14c0-2.22-1.81-4.03-4.03-4.03Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.52,14.92c-2.22,0-4.03,1.81-4.03,4.03v21.14c0,4.89-3.98,8.87-8.87,8.87s-8.87-3.98-8.87-8.87v-21.14c0-2.22-1.81-4.03-4.03-4.03s-4.03,1.81-4.03,4.03v21.14c0,9.34,7.6,16.93,16.94,16.93s16.94-7.6,16.94-16.93v-21.14c0-2.22-1.81-4.03-4.03-4.03Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.24,13.82c-4.33,0-8.42,1.52-11.66,4.31-3.24-2.79-7.33-4.31-11.66-4.31-4.79,0-9.3,1.86-12.68,5.24-6.99,6.99-6.99,18.36,0,25.35l13.59,13.59c.64.64,1.49.99,2.39.99s1.75-.35,2.39-.99c.64-.64.99-1.49.99-2.39s-.35-1.75-.99-2.39l-13.59-13.59c-4.35-4.35-4.35-11.43,0-15.78,4.35-4.35,11.43-4.35,15.78,0l13.59,13.59c.64.64,1.49.99,2.39.99s1.75-.35,2.39-.99c.64-.64.99-1.49.99-2.39s-.35-1.75-.99-2.39l-9.75-9.75c4.37-3.37,10.69-3.07,14.7.94,4.35,4.35,4.35,11.43,0,15.78l-11.29,11.29-11.29-11.29c-1.32-1.32-3.46-1.32-4.78,0-.64.64-.99,1.49-.99,2.39s.35,1.75.99,2.39l13.59,13.59c.64.64,1.49.99,2.39.99.03,0,.06,0,.09,0,.03,0,.06,0,.09,0,.9,0,1.75-.35,2.39-.99l13.59-13.59c3.39-3.39,5.25-7.89,5.25-12.68s-1.86-9.29-5.25-12.68c-3.38-3.38-7.88-5.24-12.68-5.24Z",
    fill: "#dc582a",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.89,15.6c-2.2-.94-4.76.07-5.7,2.27l-11.05,29.86-10.53-29.76v-.04c-.93-2.21-3.47-3.26-5.68-2.35-1.07.44-1.9,1.28-2.35,2.35-.44,1.06-.44,2.24,0,3.3l10.68,30.17v.04c1.34,3.2,4.43,5.26,7.89,5.26s6.48-2.02,7.83-5.15l11.2-30.26c.93-2.19-.09-4.74-2.28-5.68Z",
    fill: "#dc582a",
    strokeWidth: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuvuCmt);
export default __webpack_public_path__ + "static/media/MuvuCMT.1db792b29d95164a66d691c6e39b0e6b.svg";
export { ForwardRef as ReactComponent };